<template>
  <div>
    <v-card v-if="fetching_data == true" class="py-3 text-xs-center">
      <v-progress-circular
        :size="50"
        color="amber"
        indeterminate
        class="mb-3"
      ></v-progress-circular>
      <br />Loading store data ...
    </v-card>
    <transition name="slide-fade">
      <section v-if="fetching_data == false && store_detail != null">
        <v-tabs-items v-model="tabs.info">
          <v-tab-item
            v-for="n in lang"
            :key="n"
            transition="fade"
            reverse-transition="fade"
          >
            <v-btn
              icon
              @click="backToList()"
              style="position: absolute; left: 10px; top: 0px"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <h1 class="text-pagename text-xs-center">
              {{ store_detail.store["store_name_" + n.toLowerCase()] }}
            </h1>
          </v-tab-item>
        </v-tabs-items>
        <!-- information -->
        <v-tabs v-model="tabs.info" grow light color="primary">
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab v-for="item in lang" :key="item">{{ item }}</v-tab>
        </v-tabs>
        <v-layout row wrap>
          <v-flex xs12 md6 style="position: relative">
            <storeInformation :tabs="tabs" :store_detail="store_detail" />
          </v-flex>
          <v-flex xs12 md6 style="position: relative">
            <storeAddress :tabs="tabs" :store_detail="store_detail" />
          </v-flex>
          <v-flex xs12 md6 style="position: relative">
            <storeBank :store_detail="store_detail" />
          </v-flex>
          <v-flex xs12 md6 style="position: relative">
            <storeBusinessImage :store_detail="store_detail" />
          </v-flex>
          <v-flex xs12 md6 style="position: relative">
            <v-card disabled flat>
              <v-card-text class="pt-0">
                <storeDaily :store_detail="store_detail" />
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md6 style="position: relative">
            <v-card disabled flat>
              <v-card-text class="pt-0">
                <storeSpecial :store_detail="store_detail" />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </section>
    </transition>
  </div>
</template>

<script>
import storeDaily from "./StoreInfoDetail/StoreDailyPre";
import storeSpecial from "./StoreInfoDetail/StoreSpecial";
import storeInformation from "./StoreInfoDetail/StoreInformation";
import storeAddress from "./StoreInfoDetail/StoreAddress";
import storeBank from "./StoreInfoDetail/StoreBank";
import storeBusinessImage from "./StoreInfoDetail/StoreBusinessImage";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    storeBusinessImage,
    storeBank,
    storeDaily,
    storeSpecial,
    storeInformation,
    storeAddress,
  },
  data() {
    return {
      fetching_data: false,
      // store_detail: null,
      tabs: {
        info: null,
      },
      tabs_address: null,
      lang: ["TH", "EN", "CN"],
      lang_address: ["TH", "EN", "CN"],
    };
  },
  computed: {
    ...mapState({
      store_detail_id: (state) => state.storeBack.store_detail_id,
      store_detail: (state) => state.fetchStoreBack.store_detail,
    }),
    ...mapGetters(["isEditStoreList"]),
  },
  methods: {
    backToList() {
      this.$router.push({
        path:
          "/weserve_admin_login/control/" +
          this.$store.state.backOffice.province +
          "/storeandproduct/storemanage",
      });
    },
  },
  async created() {
    this.fetching_data = true;
    let store_detail = await this.$store.dispatch(
      "fetchStoreBack/getStoreDetail",
      this.$route.params.store_id
    );
    this.$store.commit(
      "storeBack/setStoreDetailId",
      store_detail.store.store_id
    );
    this.fetching_data = false;
    await this.$store.dispatch("fetchStoreBack/getDataType");
    await this.$store.dispatch("fetchStoreBack/getDataService");
    await this.$store.dispatch(
      "fetchPackageBack/getData",
      this.$route.params.province
    );
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
